import client from "./client";

export const attendanceReport = async (params) =>
  (await client.get("/attendance/report", { params })).data;
